var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.loading,"disabled":_vm.disabled,"block":_vm.block,"elevation":"0","color":"amber lighten-4 black--text"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }